import React from 'react';

import { useModalContext } from 'common/Context/ModalContext';

import Snackbar from './Snackbar';

type Props = {
  itemId?: string;
};

const SnackbarOutlet: React.FC<Props> = ({ itemId }) => {
  const { activeSnackBars } = useModalContext();

  const filteredSnackBars = activeSnackBars.filter((snackBar) => {
    if (!itemId) {
      return !snackBar.itemMmIdIfDetails;
    }
    return snackBar.itemMmIdIfDetails === itemId;
  });

  return (
    <>
      {filteredSnackBars.map((snackBar) => (
        <Snackbar isInItemDetails={!!itemId} key={snackBar.id} snackBar={snackBar} />
      ))}
    </>
  );
};

export default SnackbarOutlet;
